export default __webpack_public_path__ + "static/media/receipt_icon.d3230aa5.svg";